import * as Yup from 'yup';

export const CreateListSegmentFormValidationSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required(`Please enter a name for the list segment.`)
    });
};
